import { getItemAndOrderLevelApproval, getApproverActionData, getCapitalLeaseExpenditureData } from "./ApprovalAction";

const dispatchItemAndOrderLevelApproval = (dispatch: Function) => (val : any) => {
    dispatch(getItemAndOrderLevelApproval(val));
};

const dispatchGetApproverActionData = (dispatch: Function) => (val: any) => {
    dispatch(getApproverActionData(val));
};

const dispatchCapitaleaseExpenditureData = (dispatch: Function) => (val : any) => {
    dispatch(getCapitalLeaseExpenditureData(val));
};

const ApprovalDispatch = {
    dispatchItemAndOrderLevelApproval,
    dispatchGetApproverActionData,
    dispatchCapitaleaseExpenditureData
};

export default ApprovalDispatch